import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import AvailabilityCalendar from '../Blogs/AvailabilityCalendar.jsx';

/**
 * LiveAvailabilityModal - thin pre-purchase confidence modal on the TrackWidget.
 * Expects prefetched availability so the calendar paints immediately.
 */
export default function LiveAvailabilityModal({
  isOpen,
  onClose,
  slug,
  displayName,
  groupSize,
  campsiteIds,
  placeNames,
  initialStartDate,
  initialData,
  prefetchedWindows,
}) {
  const campsiteKey = campsiteIds?.length ? campsiteIds.join(',') : '';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={['md', '4xl']}
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent mx={3} my={4} maxH={['85vh', '90vh']} borderRadius="lg">
        <ModalCloseButton zIndex={2} />
        <ModalBody pb={[3, 6]} px={[2, 6]} pt={[10, 8]}>
          {slug ? (
            <AvailabilityCalendar
              key={`${slug}-${initialStartDate || 'today'}-${groupSize || 1}-${campsiteKey}`}
              slug={slug}
              displayName={displayName}
              initialStartDate={initialStartDate}
              initialData={initialData}
              prefetchedWindows={prefetchedWindows}
              daysToShow={7}
              groupSize={groupSize}
              campsiteIds={campsiteIds}
              placeNames={placeNames}
              showFallbackOnError
              framed={false}
            />
          ) : (
            <Text fontSize="sm" color="gray.600">
              Select a campground or permit to see live availability.
            </Text>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
